/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Voice_ModerateInputs */

const en_settings_voice_moderate = /** @type {(inputs: Settings_Voice_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate`)
};

const es_settings_voice_moderate = /** @type {(inputs: Settings_Voice_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderado`)
};

/**
* | output |
* | --- |
* | "Moderate" |
*
* @param {Settings_Voice_ModerateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_voice_moderate = /** @type {((inputs?: Settings_Voice_ModerateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Voice_ModerateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_voice_moderate(inputs)
	return en_settings_voice_moderate(inputs)
});